type PaginationProps = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, Math.min(page - 1, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let index = start; index <= end; index += 1) pages.push(index);

  const change = (next: number) => {
    if (next < 1 || next > totalPages || next === page) return;
    onChange(next);
  };

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        onClick={() => change(page - 1)}
        disabled={page === 1}
        className="flex cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-base" />
        上一页
      </button>

      {start > 1 && <span className="px-1 text-xs text-foreground-400">…</span>}

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => change(item)}
          aria-current={item === page ? "page" : undefined}
          className={[
            "h-9 w-9 cursor-pointer rounded-md border font-label text-xs transition-colors",
            item === page
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600",
          ].join(" ")}
        >
          {item}
        </button>
      ))}

      {end < totalPages && <span className="px-1 text-xs text-foreground-400">…</span>}

      <button
        type="button"
        onClick={() => change(page + 1)}
        disabled={page === totalPages}
        className="flex cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" />
      </button>
    </nav>
  );
}